import { LeadsBenchmarkAuthStatusActionTypes } from './constants';

/**
 * @returns {{type: string}}
 */
export const resetLeadsBenchmarkState = () => ({
  type: LeadsBenchmarkAuthStatusActionTypes.RESET_LEADS_BENCHMARK_STATE,
});

/**
 * @returns {{type: string}}
 */
export const fullResetLeadsBenchmarkState = () => ({
  type: LeadsBenchmarkAuthStatusActionTypes.FULL_RESET_LEADS_BENCHMARK_STATE,
});

/**
 * @param {Date} selectedDate
 * @param {import('../reducer.defaultState').TimeDivision} timeDivision
 */
export const savePreviouslySelectedDate = (selectedDate, timeDivision) => ({
  type: LeadsBenchmarkAuthStatusActionTypes.SAVE_PREVIOUSLY_SELECTED_DATE,
  selectedDate,
  timeDivision,
});
